module.exports = __webpack_public_path__ + "static/img/download_bg.bfe2b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg.png
// module id = sF07
// module chunks = 1